export const HorizontalDivider = (
  <div style={{ width: '100%', backgroundColor: '#BDBDBD', height: 0.5 }} />
);

export const VerticalDivider = (
  <div style={{ width: 0.5, backgroundColor: '#BDBDBD', minHeight: '100%' }} />
);
